import { useTheme } from '@mui/material';
import { CloseButton } from 'sharedComponents/Buttons/CloseButton';
import { Modal } from 'sharedComponents/Modal';
import { ModalCloseButtonContainer } from '../styles/hiringRequestStyles';
import { InviteToApplyForm } from './InviteToApplyForm';

interface InviteToApplyModalProps {
  candidateId: number;
  isOpen: boolean;
  handleClose: () => void;
}

export const InviteToApplyModal: React.FC<InviteToApplyModalProps> = ({
  candidateId,
  handleClose,
  isOpen,
}) => {
  const theme = useTheme();

  return (
    <Modal
      bodySx={{
        margin: 0,
        padding: theme.spacing(4),
        width: '500px',
        maxHeight: '90%',
        overflow: 'scroll',
        borderRadius: theme.shape.borderRadius,
        outline: 0,
      }}
      closeButton={
        <ModalCloseButtonContainer>
          <CloseButton onClick={handleClose} size="small" />
        </ModalCloseButtonContainer>
      }
      borderRadius={theme.shape.borderRadius * 2}
      title={null}
      open={isOpen}
      onClose={handleClose}
      childrenSx={{ marginTop: 0 }}
    >
      <InviteToApplyForm candidateId={candidateId} onClose={handleClose} />
    </Modal>
  );
};
